import React from "react";
import FlashcardViewer from "./viewer";
import { getBookshelfRoot } from '../../utils/bookshelf-root';

function index() {
  if (!Fraction.Brand.Supernova.enabled) {
    getBookshelfRoot().render(<FlashcardViewer />);
  } else {
    window.location.replace(`/reader/flashcards`);
  }
}

function showDeck(deckId, cardId) {
  if (!Fraction.Brand.Supernova.enabled) {
    const query = this.query || {};
    Fraction.Helpers.getUser(() => {
      // TODO better "before filter" for auth
      getBookshelfRoot().render(
        <FlashcardViewer deckId={deckId} cardId={cardId} query={query} />
      );
    });
  } else {
    window.location.replace(`/reader/flashcards/deck/${deckId}`);
  }
}

export default function () {
  // this is scoped to the router
  this.on("", index);
  this.on("deck/:deckId/?", showDeck);
  this.on("deck/:deckId/card/:cardId", showDeck);
}
